export default __webpack_public_path__ + "static/media/quizzical-list-large.6d89befc.jpg";